export default "__VITE_ASSET__a60f3442__"